<template>
  <header
    class="w-full min-w-rs-header bg-rs-header text-rs-primary flex h-[100px]"
  >
    <div class="min-w-rs-content flex mx-auto items-center">
      <span class="mx-rs-padding-main">
        <router-link
          class="block mb-1 font-bold text-2xl whitespace-nowrap"
          to="/"
          v-html="config.headerTitleText"
        >
        </router-link>
        <a
          class="block text-base whitespace-nowrap"
          :href="config.headerSubtitleUrl"
          >{{ config.headerSubtitleText }}</a
        >
      </span>
      <span class="grow"></span>
      <a class="w-[240px] mx-rs-padding-main" :href="config.logoUrl">
        <img
          :src="config.freidokBaseUrl + '/css/images/webtexte/uni_logo.png'"
          class="max-h-[100px]"
        />
      </a>
    </div>
  </header>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";

import useConfig from "@/composables/config";

const { config } = useConfig();
</script>
